import { OTHER_COUNTRY } from '@/constants/constants'
import { useCountryContext } from '@/contexts/CountryContext'
import { eventTracker } from '@/lib/events/cjrEventTracker'
import { Country } from '@/types/types'
import { Dropdown } from '@pw-tech/omni-ui'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'

const CountryOption = ({ onClick, item }: { item: Country; onClick: () => void }) => {
  const { flag = '', name = '' } = item

  return (
  <div className="flex items-center gap-4 py-1.5 px-3 cursor-pointer" onClick={onClick}>
      <Image src={flag} width={30} height={20} alt={`${name} Flag`} />
      <span>{name}</span>
    </div>
  )
}

const CountryDropdown = ({
  handleSelectedCountry,
  cameFrom = '',
}: {
  handleSelectedCountry: (c: Country, isPageGlobal: boolean) => void
  cameFrom?: string
}) => {
  const [selectedCountry, setSelectedCountry] = React.useState<Country>(OTHER_COUNTRY)
  const { countryList, loading } = useCountryContext()

  const pathname = usePathname()

  const firstPathname = pathname?.split?.('/')?.[1]

  const isPageGlobal = useMemo(() => {
    return !countryList?.some((country: Country) => country?.countryGroup?.toLowerCase() === firstPathname)
  }, [firstPathname, countryList])

  const defautCountry = useMemo(() => {
    return countryList?.find((country: Country) => country?.countryGroup?.toLowerCase() === firstPathname)
  }, [countryList, firstPathname])

  const countryGroup = defautCountry?.countryGroup?.toLowerCase() || pathname?.split?.('/')?.[1]

  const handleCountrySelect = (item: Country) => {
    if (item?._id === selectedCountry?._id) {
      return
    }

    const country = countryList.find(
      (c: Country) => c?._id?.toLowerCase() === item?._id?.toLowerCase(),
    ) as Country

    eventTracker.countryChange({
      click_section: cameFrom,
      page: 'landing',
      prev_country: selectedCountry?.countryName,
      new_country: country?.countryName,
    })

    setSelectedCountry(country)

    handleSelectedCountry(country, isPageGlobal)
  }



  const syncPropsToState = () => {
    if (isPageGlobal) {
      setSelectedCountry(OTHER_COUNTRY)
      return
    }
    const country = countryList.find(
      (c: Country) => c?.countryGroup?.toLowerCase() === countryGroup?.toLowerCase(),
    ) as Country

    if (country) {
      setSelectedCountry(country)
    }
  }

  useEffect(() => {
    if (countryList?.length > 0) {
      syncPropsToState()
    }
  }, [countryList?.length, isPageGlobal])

  if (loading) {
    return (
  <div className="w-full md:h-8 h-6">
        <div style={{ padding: '8px', textAlign: 'center', color: '#666' }}>
          Loading countries...
        </div>
      </div>
    )
  }

  return (
  <div className="w-full md:h-8 h-6">
      <Dropdown
        backgroundChangeOnCheck
        options={countryList}
        defaultValue={selectedCountry?.name}
        optionLabelKey='name'
        optionValueKey='_id'
        fullWidth
        placeholder='Select Country'
        renderOption={(_, item) => (
          <CountryOption item={item as Country} onClick={() => handleCountrySelect(item as Country)} />
        )}
        preIcon={
          <Image src={selectedCountry?.flag} width={30} height={20} alt={`${selectedCountry?.name} Flag`} />
        }
        variant='inside'
      />
    </div>
  )
}

export default CountryDropdown
